module.exports = __webpack_public_path__ + "img/conference2018.cc19f02a.jpg";